import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Plug } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/api-integrations')({
    staticData: {
        breadcrumb: {
            title: 'API and integrations',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        ui: {
            icon: Plug,
        },
    },
    component: Outlet,
});
